import React from 'react';
import { WidgetBlock } from '@/declarations/models/blocks/WidgetBlock';
import { BlockPreviewComponent } from '../../lib/declarations/EditorComponentTypes';
import { useCurrentBlock } from '../CurrentBlockProvider';

export const WidgetBlockPreview: BlockPreviewComponent = () => {
  const { block } = useCurrentBlock();
  const currentBlock = block as WidgetBlock;

  let layout = 'auto';
  let width = currentBlock?.position || 'auto';
  if (currentBlock?.position === 'right' || currentBlock?.position === 'left') {
    layout = currentBlock?.position;
    width = 'auto';
  }

  return (
    <div className={`widget widget--preview widget--${width} layout--${layout}`}>
      <div className='widget__grid'>
        <div className='article__bodytext'>
          {currentBlock?.visibletitle && <h2>{currentBlock?.title}</h2>}
          <p>{currentBlock?.body}</p>
          <p className='info'>Innhold i widget-modul vises kun i sluttportal.</p>
        </div>
      </div>
    </div>
  );
};

export default WidgetBlockPreview;
